import { useState } from "react";

export default function ToggleSwitch({ defaultChecked = false, onChange }) {
  const [checked, setChecked] = useState(defaultChecked);

  const toggle = () => {
    const newVal = !checked;
    setChecked(newVal);
    onChange && onChange(newVal);
  };

  return (
    <div
      onClick={toggle}
      style={{
        width: "48px",
        height: "24px",
        borderRadius: "100px",
        background: checked ? "rgba(8, 107, 255, 1)" : "var(--switch-back)",
        padding: "4px",
        cursor: "pointer",
        transition: "background 0.25s",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "20px",
          height: "20px",
          borderRadius: "50%",
          background: "rgba(253, 253, 253, 1)",
          transform: checked ? "translateX(21.5px)" : "translateX(-1.5px)",
          transition: "transform 0.25s",
        }}
      />
    </div>
  );
}
